<div id="formTop"></div>

<ng-container *ngIf="!authRequired; else authPrompt">
  <ion-grid *ngIf="formEmbed">
    <ion-row class="ion-align-items-start ion-justify-content-center">
      <ion-col size="12">
        <div *ngIf="formEmbedType != 'surveymonkey'" [innerHTML]="formEmbed | safe: 'html'"></div>
        <script-hack *ngIf="formEmbedType == 'surveymonkey'" formEmbedType="surveymonkey" type="text/javascript"
          id="smcx-sdk"
          src="https://widget.surveymonkey.com/collect/website/js/tRaiETqnLgj758hTBazgdy_2Fao_2FnGyFISktXKz_2BhZSBS8HSCGAqWyX5BaXT0WT2Ed.js"></script-hack>
      </ion-col>
    </ion-row>
  </ion-grid>

  <script-hack *ngIf="formEmbed && formEmbedType == 'paperform'" formEmbedType="paperform" type="text/javascript"
    id="paperform-script" src="//paperform.co/__embed.min.js"></script-hack>

  <script-hack *ngIf="formEmbed && formEmbedType == 'nter'" formEmbedType="nter" type="text/javascript" id="nter-script"
    src="https://apply.nter.io/nter-app-form.js"></script-hack>

</ng-container>
<ng-template #authPrompt>
  <div class="auth-prompt ion-content-stretched ion-text-center">
    <h2>Enter {{ formTitle }} Competition</h2>
    <p>To enter this competition please use one of the options</p>

    <ion-row class="ion-justify-content-center">
      <ion-col size="auto" class="ion-no-padding ion-padding-end">
        <app-button type="secondary" (click)="saveCurrentRoute('/auth/login')"
          [icon]="{ name: 'arrow-right', position: 'right' }">
          Login
        </app-button>
      </ion-col>
      <ion-col size="auto" class="ion-no-padding ion-padding-start">
        <app-button type="secondary" (click)="saveCurrentRoute('/auth/register')"
          [icon]="{ name: 'arrow-right', position: 'right' }">
          Register
        </app-button>
      </ion-col>
    </ion-row>
  </div>
</ng-template>